module.exports = __webpack_public_path__ + "img/course-9.ad3e59a4.png";